var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovalByAuthority(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c4c4c4;}.cls-2,.cls-9{fill:none;}.cls-3{clip-path:url(#clip-path);}.cls-4{mask:url(#mask);}.cls-5{fill:#1760ce;}.cls-6{fill:#d8dde1;isolation:isolate;opacity:0.2;}.cls-7{fill:#003c8b;}.cls-8{fill:#62de76;}.cls-9{stroke:#fafbfc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.6,
    cy: 31.4,
    r: 31.4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -20.57,
    y: -18.48,
    width: 103.87,
    height: 99.71,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_125:679",
    "data-name": "mask0 125:679"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.5,
    cy: 31.5,
    r: 31.5
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -20.57,
    y: -18.48,
    width: 103.87,
    height: 99.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M-13.14,67a6.44,6.44,0,0,0-2,4.62v.9a4.91,4.91,0,0,0,1.31,3.35l.47.47a5.38,5.38,0,0,0,3.46,1.26,8.93,8.93,0,0,0,6.23-2.52L17.15,55l.29-.29a6,6,0,0,0-.29-8.35,6.46,6.46,0,0,0-8.93,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M-14.51,50a13.11,13.11,0,0,0-4,9.41v1.87a10.17,10.17,0,0,0,2.64,6.83l1,1a10.77,10.77,0,0,0,7,2.57A18.1,18.1,0,0,0,4.79,66.46l25-24.34c.19-.2.39-.4.57-.6a12.22,12.22,0,0,0-.57-17,13.09,13.09,0,0,0-18.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M3,59.43a6.44,6.44,0,0,0-2,4.62V65A4.91,4.91,0,0,0,2.35,68.3l.47.47A5.38,5.38,0,0,0,6.28,70a8.93,8.93,0,0,0,6.23-2.52L33.29,47.4c.1-.1.2-.19.29-.29a6,6,0,0,0-.29-8.35,6.46,6.46,0,0,0-8.93,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M29,11.77a4.65,4.65,0,0,1,5,0,4.62,4.62,0,0,0,3.22.69,4.64,4.64,0,0,1,4.59,2,4.62,4.62,0,0,0,2.66,1.94,4.61,4.61,0,0,1,3.36,3.73A4.64,4.64,0,0,0,49.49,23,4.63,4.63,0,0,1,51,27.79a4.66,4.66,0,0,0,.34,3.28,4.63,4.63,0,0,1-.52,5,4.56,4.56,0,0,0-1,3.13,4.63,4.63,0,0,1-2.51,4.35A4.57,4.57,0,0,0,45.13,46a4.63,4.63,0,0,1-4.07,3,4.64,4.64,0,0,0-3,1.34,4.63,4.63,0,0,1-4.91,1,4.58,4.58,0,0,0-3.3,0,4.63,4.63,0,0,1-4.91-1,4.64,4.64,0,0,0-3-1.34,4.63,4.63,0,0,1-4.07-3,4.57,4.57,0,0,0-2.2-2.44,4.63,4.63,0,0,1-2.51-4.35,4.56,4.56,0,0,0-1-3.13,4.63,4.63,0,0,1-.52-5A4.66,4.66,0,0,0,12,27.79,4.63,4.63,0,0,1,13.51,23a4.64,4.64,0,0,0,1.65-2.85,4.61,4.61,0,0,1,3.36-3.73,4.65,4.65,0,0,0,2.66-1.94,4.64,4.64,0,0,1,4.59-2A4.62,4.62,0,0,0,29,11.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M25,31.5l4.43,4.43,8.85-8.86"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalByAuthority);
export default __webpack_public_path__ + "static/media/approval_by_authority.bf0d7393.svg";
export { ForwardRef as ReactComponent };